import { render } from "./SRC.vue?vue&type=template&id=f15de49a"
import script from "./SRC.vue?vue&type=script&lang=js"
export * from "./SRC.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__